import React from "react"
import PropTypes from "prop-types"
import Radium from "higher-order-components/configured-radium/"

const ServiceMainPanel = Radium((props = {}) => {
  const { activeService, services, compact } = props

  return (
    <div style={styles.wrapper}>
      <div
        style={{
          width: "100%",
          maxWidth: "70em",
          margin: "auto",
          boxSizing: "border-box",
          padding: "1em 0"
        }}>
        <div style={{ position: "relative", transition: "height 1s ease-in-out" }}>
          {services.map(s => {
            return (
              <div
                key={s.code}
                style={{
                  columnCount: compact ? 1 : 3,
                  MozColumnCount: compact ? 1 : 3,
                  margin: "auto",
                  paddingTop: compact ? "2em" : "3em",
                  paddingBottom: compact ? "2em" : "3em",
                  display: s.item.factoryCodeEntity.code === activeService.code ? "block" : "none"
                }}>
                {s.item.operationActions.map(category => (
                  <div style={{ display: "block", paddingBottom: "1.5em" }} key={category.name}>
                    <h4 style={styles.scheduledMaintenanceItem}>{category.name}</h4>
                    {category.operations.map(
                      o =>
                        (o.name === "M-MDS M-MDS" ? null : (
                          <span key={o.subOpCode} style={styles.scheduledMaintenanceItem}>
                            {o.name}
                          </span>
                        ))
                    )}
                  </div>
                ))}
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
})

const styles = {
  wrapper: {
    width: "100%"
  },

  basicsLastLine: {
    width: "100%",
    textTransform: "uppercase",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between"
  },

  scheduledMaintenanceItem: {
    display: "block",
    padding: "0.3em",
    fontSize: "16px",
    marginTop: "0",
    marginBottom: "5px"
  }
}

export default ServiceMainPanel

ServiceMainPanel.propTypes = {
  services: PropTypes.array,
  activeService: PropTypes.object,
  fullDetailsURL: PropTypes.string,
  factoryCode: PropTypes.string,
  activeServiceCodeIndex: PropTypes.number,
  compact: PropTypes.bool,
  onServiceSelect: PropTypes.func
}



// WEBPACK FOOTER //
// ./src/components/mymazda/service/panel.jsx